// extracted by mini-css-extract-plugin
module.exports = {"order-notes":"orderDetailsNotes_order-notes__Pclkg"};